<input
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [ngClass]="inputClasses"
    [ngStyle]="styles"
    type="checkbox"
    [id]="id"
    [name]="controlName"
    [attr.title]="title ? title : null"
    [attr.aria-label]="ariaLabel ? labelText: null"
    [attr.required]="control.errors?.['required'] ? 'required' : null"
    [attr.role]="role ? role : null" />
<fdx-validation [control]="control"
    [labelText]="labelText"
    [customValidationText]="customValidationText"
    [submitted]="form.submitted"
    [ngClass]="{'invalid-feedback': !tooltipValidation, 'invalid-tooltip': tooltipValidation}"
    [showIcon]="true"
></fdx-validation>
